import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export const useUrlNavigation = (defaultPage = 'dashboard') => {
  const navigate = useNavigate()
  const location = useLocation()
  
  // URL'den sayfa adını al
  const getPageFromUrl = () => {
    const hash = location.hash.substring(1) // # işaretini kaldır
    return hash || defaultPage
  }

  const [currentPage, setCurrentPage] = useState(() => {
    const pageFromUrl = getPageFromUrl()
    return pageFromUrl
  })

  // URL değiştiğinde state'i güncelle
  useEffect(() => {
    const handleHashChange = () => {
      const newPage = getPageFromUrl()
      // Sadece ana sayfalar için hash değişikliklerini dinle
      const mainPages = ['dashboard', 'teacher-dashboard', 'education', 'settings', 'leaderboard']
      if (mainPages.includes(newPage) || newPage === defaultPage) {
        setCurrentPage(newPage)
      }
    }
    
    // Hash değişikliklerini dinle
    window.addEventListener('hashchange', handleHashChange)
    
    // Browser geri/ileri butonları için
    const handlePopState = (event) => {
      event.preventDefault()
      const newPage = getPageFromUrl()
      // Sadece ana sayfalar için hash değişikliklerini dinle
      const mainPages = ['dashboard', 'teacher-dashboard', 'education', 'settings', 'leaderboard']
      if (mainPages.includes(newPage) || newPage === defaultPage) {
        setCurrentPage(newPage)
      }
    }
    
    window.addEventListener('popstate', handlePopState)
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange)
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  // Sayfa değiştiğinde URL'yi güncelle
  const navigateToPage = (page) => {
    setCurrentPage(page)
    
    // Sadece ana sayfalar için hash güncelle
    const mainPages = ['dashboard', 'teacher-dashboard', 'education', 'settings', 'leaderboard']
    if (mainPages.includes(page)) {
      window.location.hash = page
    }
  }

  // Geri gitme fonksiyonu - site içinde kalması için
  const goBack = () => {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      // Eğer history yoksa default sayfaya git
      navigateToPage(defaultPage)
    }
  }

  return {
    currentPage,
    navigateToPage,
    goBack,
    setCurrentPage: navigateToPage // Eski API uyumluluğu için
  }
}
